import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { useContext } from 'react';
import ExportPdfContext from '../ExportPdfContext';

const styles = StyleSheet.create({
    title: {
        fontFamily: 'PDF Font Bold',
        marginBottom: 5,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    subTitle: {
        fontFamily: 'PDF Font Bold',
        fontSize: 12,
        marginBottom: 5,
        marginTop: 16,
    },
});

const PdfPageTitle = ({ sub, children }: { sub?: boolean; children: React.ReactNode }) => {
    const { orientation } = useContext(ExportPdfContext);

    return (
        <View>
            <Text style={sub ? styles.subTitle : [styles.title, { fontSize: orientation === 'landscape' ? 16 : 21 }]}>
                {children}
            </Text>
        </View>
    );
};

export default PdfPageTitle;
